export default function Email() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <circle opacity="0.16" cx="24" cy="24" r="24" fill="#4888EE" />
      <path
        transform="translate(9, 9), scale(1.3, 1.3)"
        d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6M20 6L12 11L4 6H20M20 18H4V8L12 13L20 8V18Z"
        fill="#4888EE"
      />
    </svg>
  )
}
